import r from "../helpers/isAbsoluteURL.js";
import t from "../helpers/combineURLs.js";
function m(i, o) {
  return i && !r(o) ? t(i, o) : o;
}
export { m as default };
